import React, { useEffect, useState } from 'react';

import { InputGroup, TextField } from '../../../../../../Styles';

import { validateSupplierProductId } from '../../../../../../../commons/utils';

const ItemID = ({ label = 'Item ID', value = '', error = '', disabled = false, onChange = null, onError = null }) => {
	const [inputValue, setInputValue] = useState(value);

	const validate = () => {
		let error = null;

		if (!inputValue) {
			error = `${label} cannot be empty.`;
		} else if (inputValue?.length > 150) {
			error = `${label} is too long.`;
		} else if (!validateSupplierProductId(inputValue)) {
			error = `${label} is invalid.`;
		}

		onError(error);
		return !error;
	};

	useEffect(() => {
		if (!disabled) {
			validate();
			onChange(inputValue);
		}
	}, [inputValue]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<InputGroup
			label={label}
			markRequired={true}
			inputLength={(inputValue || '').length}
			maxLength={150}
			message={`${label} cannot contain underscores, slash or colon.`}
			error={error}
		>
			<TextField
				name={'item_id'}
				placeholder='Enter value'
				value={inputValue}
				disabled={disabled}
				onChange={(e) => {
					setInputValue(e.target.value);
				}}
				error={error}
			/>
		</InputGroup>
	);
};

export default ItemID;
